import { Flex, Text, Paragraph } from '@zillow/constellation';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { getWholeDollars } from '../../utils/zhl-calculator.js';
import { useLastValidAmortizationValues } from './AmortizationCalculator.utils.js';

var OUTPUTS = [{
  label: 'Total principal',
  accessor: 'totalPrincipal',
  fontColor: 'backgroundDarkGreen'
}, {
  label: 'Total interest',
  accessor: 'totalInterest',
  fontColor: 'backgroundDarkAqua'
}, {
  label: 'Principal & interest',
  accessor: 'totalPayment',
  fontColor: 'backgroundDarkPurple'
}];
var AmortizationPaymentSummary = function AmortizationPaymentSummary() {
  var form = useFormContext();
  var lastValidValues = useLastValidAmortizationValues(form);
  return /*#__PURE__*/React.createElement(Flex, {
    flex: "1",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: "md",
    "aria-live": "polite",
    "aria-atomic": "true",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    as: "h2",
    "font-weight": "normal"
  }, "Estimated monthly payment"), /*#__PURE__*/React.createElement(Text, {
    fontType: "h2",
    marginBottom: "sm"
  }, getWholeDollars(lastValidValues.calculations.monthlyPayment)), OUTPUTS.map(function (_ref, index) {
    var label = _ref.label,
      accessor = _ref.accessor,
      fontColor = _ref.fontColor;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: "xs",
      marginBottom: "xs",
      last: index === OUTPUTS.length - 1,
      key: accessor,
      style: {
        borderBottom: index !== OUTPUTS.length - 1 ? "1px solid #A7A6AB" : null,
        width: '80%'
      }
    }, /*#__PURE__*/React.createElement(Paragraph, null, label), /*#__PURE__*/React.createElement(Text, {
      fontColor: fontColor,
      fontType: "h4"
    }, getWholeDollars(lastValidValues.calculations[accessor]))));
  }));
};
var AmortizationPaymentSummary$1 = AmortizationPaymentSummary;

export { AmortizationPaymentSummary$1 as default };
